/// React router dom
import { Outlet, Route, Routes } from "react-router-dom";
/// Css
import "./chart.css";
import "./index.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";

/// Pages
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import LockScreen from "./pages/LockScreen";

//Scroll To Top
import ScrollToTop from "./layouts/ScrollToTop";

import ComingSoon from "./pages/ComingSoon";
import CustomerList from "./components/Customers/CustomerList";
import Cash from "./components/Cash/Cash";
import BeneficiaryList from "./components/Beneficiaries/BeneficiaryList";
import ReportList from "./components/Report/ReportList";
import RequestsList from "./components/Requests/RequestsList";
import TopUpWithdrawList from "./components/TopUpWithdraw/TopUpWithdrawList";
import RefundsList from "./components/Refunds/RefundsList";
import TransactionsList from "./components/Transactions/TransactionsList";
import NotificationsList from "./components/Notifications/NotificationsList";
import CashierManagementList from "./components/CashierManagement/CashierManagementList";
import CashVaultManagementList from "./components/CashVaultManagement/CashVaultManagementList";

const Markup = () => {
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  const allroutes = [
    { url: "", component: <Cash /> },
    { url: "cash", component: <Cash /> },
    { url: "customers", component: <CustomerList /> },
    { url: "beneficiaries", component: <BeneficiaryList /> },
    { url: "transactions", component: <TransactionsList /> },
    { url: "refunds", component: <RefundsList /> },
    { url: "requests", component: <RequestsList /> },
    { url: "report", component: <ReportList /> },
    {
      url: "topup-withdraw",
      component: <TopUpWithdrawList />,
    },
    { url: "notifications", component: <NotificationsList /> },
    { url: "cashier-management", component: <CashierManagementList /> },
    {
      url: "cash-vault-management",
      component: <CashVaultManagementList />,
    },
  ];

  return (
    <>
      <Routes>
        <Route path="page-lock-screen" element={<LockScreen />} />
        <Route path="page-error-400" element={<Error400 />} />
        <Route path="page-error-403" element={<Error403 />} />
        <Route path="page-error-404" element={<Error404 />} />
        <Route path="page-error-500" element={<Error500 />} />
        <Route path="page-error-503" element={<Error503 />} />
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  return (
    <div id="main-wrapper" className="show">
      <Nav />
      <div
        className="content-body"
        style={{ minHeight: window.screen.height - 45 }}
      >
        <Outlet />
      </div>
    </div>
  );
}

export default Markup;
